import React from 'react';
import { cn } from 'utils/utils';

const Skeleton: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => {
  return <div className={cn('animate-pulse rounded-md bg-gray-300', className)} {...props} />;
};

export default Skeleton;
